/**
 * Partners that are part of Google's Additional Consent Mode
 * https://support.google.com/admanager/answer/9681920?hl=en&ref_topic=9760861
 * Partner list adapted from
 * https://storage.googleapis.com/tcfac/additional-consent-providers.csv
 */
export const acPartners = [
  {
    providerId: 7,
    providerName: 'Amazon',
    policyUrl: 'https://www.amazon.co.uk/gp/help/customer/display.html?nodeId=201909010'
  },
  {
    providerId: 326,
    providerName: 'Microsoft',
    policyUrl: 'https://privacy.microsoft.com/en-us/privacystatement'
  },
  {
    providerId: 1205,
    providerName: 'Netflix',
    policyUrl: 'http://www.netflix.com/google-3PAS-info'
  },
  {
    providerId: 89,
    providerName: 'Facebook',
    policyUrl: 'https://www.facebook.com/about/privacy/update'
  },
  {
    providerId: 440,
    providerName: 'Centro',
    policyUrl: 'http://privacy.centro.net/'
  },
  {
    providerId: 1651,
    providerName: 'Mobitrans',
    policyUrl: 'http://www.mobitrans.net/privacy-policy/'
  },
  {
    providerId: 11,
    providerName: 'Acuityads',
    policyUrl: 'https://www.acuityads.com/privacy-policy/'
  },
  {
    providerId: 1799,
    providerName: 'LinkedIn',
    policyUrl: 'https://www.linkedin.com/legal/privacy-policy'
  },
  {
    providerId: 2973,
    providerName: 'Carrefour',
    policyUrl: 'https://www.carrefour.es/politica-de-privacidad/mas-info/'
  },
  {
    providerId: 162,
    providerName: 'PulsePoint',
    policyUrl: 'https://www.pulsepoint.com/privacy-policy'
  },
  {
    providerId: 2440,
    providerName: 'Fiverr',
    policyUrl: 'https://www.fiverr.com/privacy-policy'
  },
  {
    providerId: 184,
    providerName: 'eBay',
    policyUrl: 'https://www.ebay.com/help/policies/member-behaviour-policies/user-privacy-notice-privacy-policy?id=4260#section12'
  },
  {
    providerId: 1097,
    providerName: 'Cloudflare',
    policyUrl: 'https://www.cloudflare.com/security-policy/'
  },
  {
    providerId: 144,
    providerName: 'Constant Contact',
    policyUrl: 'https://www.constantcontact.com/legal/privacy-statement'
  },
  {
    providerId: 1733,
    providerName: 'LoopMe',
    policyUrl: 'https://loopme.com/privacy/'
  },
  {
    providerId: 1968,
    providerName: 'KEEN',
    policyUrl: 'https://www.ingenio.com/privacypolicy'
  },
  {
    providerId: 2684,
    providerName: "LANDS' END",
    policyUrl: 'https://www.landsend.com/customerservice/legal_policies/privacy/'
  },
  {
    providerId: 3019,
    providerName: 'Next',
    policyUrl: 'https://www.next.co.uk/privacy'
  },
  {
    providerId: 3163,
    providerName: 'Reset Digital',
    policyUrl: 'http://www.resetdigital.co/privacy-policy/'
  },
  {
    providerId: 986,
    providerName: 'LiquidM',
    policyUrl: 'https://liquidm.com/privacy-policy/'
  },
  {
    providerId: 153,
    providerName: 'Crimtan',
    policyUrl: 'https://crimtan.com/privacy-ctl/'
  },
  {
    providerId: 2577,
    providerName: 'AppsFlyer',
    policyUrl: 'https://www.appsflyer.com/privacy-policy/'
  },
  {
    providerId: 1456,
    providerName: 'ZypMedia',
    policyUrl: 'http://www.zypmedia.com/privacy-policy'
  },
  {
    providerId: 1671,
    providerName: 'Addictive Mobility',
    policyUrl: 'https://addictivemobility.com/privacy.html'
  },
  {
    providerId: 2225,
    providerName: 'JustWatch',
    policyUrl: 'https://www.justwatch.com/uk/imprint'
  },
  {
    providerId: 2571,
    providerName: 'DENTSU',
    policyUrl: 'http://www.dentsu.co.jp/terms/data_policy.html'
  },
  {
    providerId: 448,
    providerName: 'Sociomantic',
    policyUrl: 'https://www.sociomantic.com/privacy/en/'
  },
  {
    providerId: 1827,
    providerName: 'Momentum',
    policyUrl: 'https://www.m0mentum.co.jp/ja/privacy-policy.html'
  },
  {
    providerId: 259,
    providerName: 'intelliAd',
    policyUrl: 'https://www.intelliad.de/datenschutz'
  },
  {
    providerId: 2510,
    providerName: 'KAYAK',
    policyUrl: 'https://www.kayak.com/privacy'
  },
  {
    providerId: 2373,
    providerName: 'Dentsu Aegis Network',
    policyUrl: 'http://www.dentsu.com/termsofuse/data_policy.html'
  },
  {
    providerId: 350,
    providerName: 'GfK',
    policyUrl: 'https://sensic.net/'
  },
  {
    providerId: 1225,
    providerName: 'DYNADMIC',
    policyUrl: 'http://eu.dynadmic.com/privacy-policy/'
  },
  {
    providerId: 3162,
    providerName: 'IronNet Cybersecurity',
    policyUrl: 'https://ironnet.com/privacy-statement/'
  },
  {
    providerId: 2856,
    providerName: 'congstar',
    policyUrl: 'https://www.congstar.de/fileadmin/files_congstar/documents/2019/Datenschutz/Datenschutzhinweise_congstar_Webseite.pdf'
  },
  {
    providerId: 2846,
    providerName: 'Milanoo',
    policyUrl: 'https://www.milanoo.com/help/index-id-1459-childcat-2043.html'
  },
  {
    providerId: 2997,
    providerName: 'ADLOOP',
    policyUrl: 'https://adloop.co/en/privacy-policy/'
  },
  {
    providerId: 348,
    providerName: 'Nielsen',
    policyUrl: 'https://www.nielsen.com/us/en/legal/privacy-statement/digital-measurement/'
  },
  {
    providerId: 2850,
    providerName: 'Hargreaves Lansdown',
    policyUrl: 'https://www.hl.co.uk/privacy-policy'
  },
  {
    providerId: 272,
    providerName: 'iProspect',
    policyUrl: 'https://www.iprospect.com/en/ph/privacy-policy/'
  },
  {
    providerId: 2886,
    providerName: 'Calzedonia',
    policyUrl: 'https://world.calzedonia.com/custserv/custserv.jsp?pageName=faq-legal-information#tab1'
  },
  {
    providerId: 1875,
    providerName: 'TAPTAP',
    policyUrl: 'http://www.taptapnetworks.com/privacy_policy/'
  },
  {
    providerId: 202,
    providerName: 'Eyereturn Marketing',
    policyUrl: 'https://eyereturnmarketing.com/privacy/'
  },
  {
    providerId: 1286,
    providerName: 'Wider Planet',
    policyUrl: 'http://info.jp.widerplanet.com/policy/privacy?lang=en'
  },
  {
    providerId: 2663,
    providerName: 'Bombora',
    policyUrl: 'http://bombora.com/privacy'
  },
  {
    providerId: 228,
    providerName: 'Goodway Group',
    policyUrl: 'https://goodwaygroup.com/privacy-policy/'
  },
  {
    providerId: 230,
    providerName: 'GroovinAds',
    policyUrl: 'http://www.groovinads.com/en#privacy_modal'
  },
  {
    providerId: 1143,
    providerName: 'Audience2Media',
    policyUrl: 'https://www.audience2media.com/privacy'
  },
  {
    providerId: 3017,
    providerName: 'Boston Consulting Group',
    policyUrl: 'https://www.bcg.com/en-us/about/privacy-policy.aspx'
  },
  {
    providerId: 167,
    providerName: 'Demandbase',
    policyUrl: 'https://www.demandbase.com/privacy-policy/'
  },
  {
    providerId: 550,
    providerName: 'CyberAgent',
    policyUrl: 'https://privacy-policy.cyberagent.ai/index-en.html'
  },
  {
    providerId: 1838,
    providerName: 'ChannelAdvisor',
    policyUrl: 'https://www.channeladvisor.com/privacy-policy/'
  },
  {
    providerId: 2808,
    providerName: 'Justpremium',
    policyUrl: 'https://justpremium.com/terms-conditions/?section=privacy_policy'
  },
  {
    providerId: 1703,
    providerName: 'Clickagy',
    policyUrl: 'https://www.clickagy.com/privacy/'
  },
  {
    providerId: 70,
    providerName: 'Akamai',
    policyUrl: 'http://www.akamai.com/compliance/privacy'
  },
  {
    providerId: 46,
    providerName: 'Adriver',
    policyUrl: 'https://www.adriver.ru/about/privacy-en/'
  },
  {
    providerId: 1166,
    providerName: 'Bridgewell',
    policyUrl: 'https://www.bridgewell.com/privacy/'
  },
  {
    providerId: 12,
    providerName: 'LiveRamp',
    policyUrl: 'https://liveramp.com/service-privacy-policy/'
  },
  {
    providerId: 211,
    providerName: 'Forbes',
    policyUrl: 'https://www.forbes.com/privacy/english/'
  },
  {
    providerId: 1735,
    providerName: 'Impact',
    policyUrl: 'https://impact.com/privacy-policy/'
  },
  {
    providerId: 66,
    providerName: 'affilinet',
    policyUrl: 'https://www.affili.net/uk/footeritem/privacy-policy'
  },
  {
    providerId: 2569,
    providerName: 'Reactive',
    policyUrl: 'http://reactive-agency.ru/privacy.html'
  },
  {
    providerId: 1810,
    providerName: 'Foursquare',
    policyUrl: 'https://foursquare.com/legal/privacy'
  },
  {
    providerId: 2039,
    providerName: 'Kadam',
    policyUrl: 'https://www.kadam.net/ru/privacy-policy'
  },
  {
    providerId: 725,
    providerName: 'Mediarithmics',
    policyUrl: 'https://www.mediarithmics.com/en/data-privacy.html'
  },
  {
    providerId: 2677,
    providerName: 'Vimeo',
    policyUrl: 'https://vimeo.com/cookie_policy'
  },
  {
    providerId: 3033,
    providerName: 'Zeta Global',
    policyUrl: 'https://zetaglobal.com/privacy-policy/'
  },
  {
    providerId: 3128,
    providerName: 'Pandora',
    policyUrl: 'https://it.pandora.net/it/politica-sui-cookie/cookie-policy.html'
  },
  {
    providerId: 2768,
    providerName: 'Overstock',
    policyUrl: 'https://help.overstock.com/help/s/article/PRIVACY-AND-SECURITY-POLICY'
  },
  {
    providerId: 1415,
    providerName: 'Rackspace',
    policyUrl: 'http://www.rackspace.com/gdpr'
  },
  {
    providerId: 2572,
    providerName: 'Snap Inc.',
    policyUrl: 'https://www.snap.com/en-US/privacy/privacy-policy/'
  },
  {
    providerId: 1967,
    providerName: 'Qantas',
    policyUrl: 'http://www.qantas.com/au/en/support/privacy-and-security.html#our-contact-details'
  },
  {
    providerId: 39,
    providerName: 'Digilant',
    policyUrl: 'https://www.digilant.com/privacy-policy/'
  },
  {
    providerId: 62,
    providerName: 'comScore',
    policyUrl: 'https://www.comscore.com/About-comScore/Privacy-Policy'
  },
  {
    providerId: 108,
    providerName: 'Booking.com',
    policyUrl: 'https://www.booking.com/content/privacy.en-gb.html'
  },
  {
    providerId: 149,
    providerName: 'IBM',
    policyUrl: 'https://www.ibm.com/customer-engagement/digital-marketing/gdpr'
  },
  {
    providerId: 192,
    providerName: 'engageBDR',
    policyUrl: 'http://engagebdr.com/terms/EngageBDR_Buyer_Addendum_December_2015.pdf'
  },
  {
    providerId: 221,
    providerName: 'Gemius',
    policyUrl: 'https://www.gemius.com/cookie-policy.html'
  },
  {
    providerId: 253,
    providerName: 'Infectious Media',
    policyUrl: 'https://impressiondesk.com/'
  },
  {
    providerId: 327,
    providerName: 'Mixpo',
    policyUrl: 'http://www.netsertive.com/privacy-policy/'
  },
  {
    providerId: 338,
    providerName: 'Ignition One',
    policyUrl: 'https://www.ignitionone.com/privacy-policy/gdpr-subject-access-requests/'
  },
  {
    providerId: 415,
    providerName: 'Resonate',
    policyUrl: 'https://www.resonate.com/privacy-policy/'
  },
  {
    providerId: 482,
    providerName: 'Videology',
    policyUrl: 'https://videologygroup.com/en/privacy-policy/'
  },
  {
    providerId: 503,
    providerName: 'Underdog Media',
    policyUrl: 'https://underdogmedia.com/privacy-policy/gdpr'
  },
  {
    providerId: 505,
    providerName: 'Undertone',
    policyUrl: 'https://www.undertone.com/privacy/'
  },
  {
    providerId: 588,
    providerName: 'Innovid',
    policyUrl: 'http://www.innovid.com/privacy-policy'
  },
  {
    providerId: 780,
    providerName: 'LiveIntent',
    policyUrl: 'https://liveintent.com/services-privacy-policy/'
  },
  {
    providerId: 981,
    providerName: 'Vodafone GmbH',
    policyUrl: 'https://www.vodafone.de/unternehmen/datenschutz-privatsphaere.html'
  },
  {
    providerId: 1092,
    providerName: 'Walmart',
    policyUrl: 'https://corporate.walmart.com/privacy-security/walmart-privacy-policy'
  },
  {
    providerId: 1095,
    providerName: 'Manage.com',
    policyUrl: 'https://www.manage.com/privacy-policy/'
  },
  {
    providerId: 1126,
    providerName: 'Salesforce DMP',
    policyUrl: 'https://www.salesforce.com/company/privacy/'
  },
  {
    providerId: 1171,
    providerName: 'Pixalate',
    policyUrl: 'http://www.pixalate.com/privacypolicy/'
  },
  {
    providerId: 1178,
    providerName: 'YOC',
    policyUrl: 'https://yoc.com/privacy/'
  },
  {
    providerId: 1329,
    providerName: 'EMX Digital',
    policyUrl: 'https://emxdigital.com/privacy'
  },
  {
    providerId: 1509,
    providerName: 'White Ops',
    policyUrl: 'https://www.whiteops.com/privacy'
  },
  {
    providerId: 1516,
    providerName: 'Chocolate Platform',
    policyUrl: 'https://chocolateplatform.com/privacy-policy/'
  },
  {
    providerId: 1558,
    providerName: 'TripAdvisor',
    policyUrl: 'https://tripadvisor.mediaroom.com/us-privacy-policy'
  },
  {
    providerId: 1579,
    providerName: 'Taptica',
    policyUrl: 'https://www.taptica.com/privacy/'
  },
  {
    providerId: 1832,
    providerName: 'Housing.com',
    policyUrl: 'https://housing.com/terms.html'
  },
  {
    providerId: 2103,
    providerName: 'Crutchfield',
    policyUrl: 'https://www.crutchfield.com/support/privacy.aspx'
  },
  {
    providerId: 2316,
    providerName: 'Expedia, Inc.',
    policyUrl: 'https://www.expedia.co.uk/p/support/privacy'
  },
  {
    providerId: 2411,
    providerName: 'LKQD',
    policyUrl: 'https://www.nexstardigital.com/privacy/'
  },
  {
    providerId: 2595,
    providerName: 'Parrable',
    policyUrl: 'https://www.parrable.com/privacy'
  },
  {
    providerId: 2642,
    providerName: 'Delta Air Lines',
    policyUrl: 'https://www.delta.com/us/en/legal/privacy-and-security'
  },
  {
    providerId: 2710,
    providerName: 'AdColony',
    policyUrl: 'https://www.adcolony.com/gdpr/'
  },
  {
    providerId: 2729,
    providerName: 'TotalJobs Group Ltd',
    policyUrl: 'https://www.totaljobs.com/privacy-policy'
  },
  {
    providerId: 2767,
    providerName: 'Hotels.com L. P.',
    policyUrl: 'https://uk.hotels.com/customer_care/privacy.html'
  },
  {
    providerId: 2778,
    providerName: 'Oracle Data Cloud',
    policyUrl: 'https://www.oracle.com/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html'
  },
  {
    providerId: 2779,
    providerName: 'GroupM',
    policyUrl: 'https://www.groupm.com/privacy-policy'
  },
  {
    providerId: 2786,
    providerName: 'Captify',
    policyUrl: 'http://www.captify.co.uk/technologies/brand-safety'
  },
  {
    providerId: 2867,
    providerName: 'Bose',
    policyUrl: 'https://www.bose.co.uk/en_gb/legal/cookie_policy.html'
  },
  {
    providerId: 2887,
    providerName: 'Uber Technologies Inc.',
    policyUrl: 'https://privacy.uber.com/policy'
  },
  {
    providerId: 2912,
    providerName: 'Dianomi',
    policyUrl: 'https://www.dianomi.com/legal/privacy.epl'
  },
  {
    providerId: 2913,
    providerName: 'Adapt Retail - Advertising Platform',
    policyUrl: 'https://www.adaptretail.com/privacy/application/'
  },
  {
    providerId: 2914,
    providerName: 'Fastbooking SAS',
    policyUrl: 'https://www.fastbooking.com/privacy-policy/'
  },
  {
    providerId: 2917,
    providerName: 'Movable Ink',
    policyUrl: 'https://movableink.com/legal/privacy'
  },
  {
    providerId: 2922,
    providerName: 'Glassdoor, Inc.',
    policyUrl: 'https://www.glassdoor.com/gdpr/index.htm'
  },
  {
    providerId: 2923,
    providerName: 'AdUnity LTD',
    policyUrl: 'https://www.adunity.com/privacy-policy.html'
  },
  {
    providerId: 2942,
    providerName: 'Mintegral',
    policyUrl: 'https://www.mintegral.com/en/privacy'
  },
  {
    providerId: 2945,
    providerName: 'SunMedia',
    policyUrl: 'https://www.sunmedia.tv/en/legal'
  },
  {
    providerId: 2947,
    providerName: 'geolad GmbH',
    policyUrl: 'https://geolad.com/privacy/'
  },
  {
    providerId: 2949,
    providerName: 'Shutterstock, Inc.',
    policyUrl: 'https://www.shutterstock.com/privacy'
  },
  {
    providerId: 2950,
    providerName: 'TheINDUSTRY AG',
    policyUrl: 'https://www.adspot.ch/j/cookies/policy'
  },
  {
    providerId: 2956,
    providerName: 'Maytrics',
    policyUrl: 'https://www.maytrics.com/privacy.php'
  },
  {
    providerId: 2968,
    providerName: 'MHU',
    policyUrl: 'http://adprov.io/privacy-policy/'
  },
  {
    providerId: 2970,
    providerName: 'AdButler',
    policyUrl: 'https://adbutler.com/gdpr.spark'
  },
  {
    providerId: 2977,
    providerName: 'Pubnative',
    policyUrl: 'https://pubnative.net/privacy-notice'
  },
  {
    providerId: 2979,
    providerName: 'Rebel AI LLC',
    policyUrl: 'https://rebelai.com/gdpr'
  },
  {
    providerId: 2983,
    providerName: 'Data2Decisions',
    policyUrl: 'http://data2decisions.com/privacy-and-cookie-policy/'
  },
  {
    providerId: 3000,
    providerName: 'We Adapt',
    policyUrl: 'https://weadapt.digital/privacy-policy/'
  },
  {
    providerId: 3002,
    providerName: 'TrafficGuard',
    policyUrl: 'https://www.trafficguard.ai/gdpr/'
  },
  {
    providerId: 3008,
    providerName: 'Partnerize',
    policyUrl: 'https://partnerize.com/en/privacy-policy'
  },
  {
    providerId: 3009,
    providerName: 'Click2Buy',
    policyUrl: 'https://www.clic2buy.com/conditions-generales-dutilisation/'
  },
  {
    providerId: 3024,
    providerName: 'Method Media Intelligence',
    policyUrl: 'https://www.methodmi.com/gdpr'
  },
  {
    providerId: 3034,
    providerName: 'Clario',
    policyUrl: 'https://www.clar.io/privacy'
  },
  {
    providerId: 3048,
    providerName: 'YouAppi',
    policyUrl: 'http://youappi.com/privacy-policy'
  },
  {
    providerId: 3052,
    providerName: 'Koninklijke Philips N.V.',
    policyUrl: 'https://www.philips.com/a-w/privacy-notice.html#triggername=info_how_we_protect_data'
  },
  {
    providerId: 3053,
    providerName: 'AdPlayer.Pro',
    policyUrl: 'https://adplayer.pro/privacy'
  },
  {
    providerId: 3059,
    providerName: 'Factual Inc.',
    policyUrl: 'https://www.factual.com/privacy'
  },
  {
    providerId: 3060,
    providerName: 'Beintoo',
    policyUrl: 'https://beintoo.com/privacy-cookie-policy-2/'
  },
  {
    providerId: 3076,
    providerName: 'EasyPlatform',
    policyUrl: 'https://easyplatform.com/policy.php'
  },
  {
    providerId: 3077,
    providerName: 'Retargetly',
    policyUrl: 'https://retargetly.com/privacy-policy/'
  },
  {
    providerId: 3078,
    providerName: 'Illuma Technology',
    policyUrl: 'https://www.weareilluma.com/end-user-policy'
  },
  {
    providerId: 3089,
    providerName: 'Transmit.Live',
    policyUrl: 'https://transmit.live/privacy-policy/'
  },
  {
    providerId: 3093,
    providerName: 'MMG',
    policyUrl: 'https://themoneydaily.com/privacy-policy/'
  },
  {
    providerId: 3094,
    providerName: 'Spirable',
    policyUrl: 'https://www.spirable.com/privacy-policy'
  },
  {
    providerId: 3112,
    providerName: 'Buzzoola',
    policyUrl: 'https://buzzoola.com/en/privacy'
  },
  {
    providerId: 3120,
    providerName: 'Raptor Services',
    policyUrl: 'https://raptorsmartadvisor.com/privacy-policy-ads/'
  },
  {
    providerId: 3121,
    providerName: 'Advenue',
    policyUrl: 'https://www.advenuemedia.co.uk/privacy-policy/'
  },
  {
    providerId: 3124,
    providerName: 'SmartyAds',
    policyUrl: 'https://smartyads.com/privacy-policy'
  },
  {
    providerId: 3126,
    providerName: 'clean.io',
    policyUrl: 'https://clean.io/privacy-policy/'
  },
  {
    providerId: 3149,
    providerName: 'Adimo',
    policyUrl: 'https://adimo.co/privacy-policy'
  },
  {
    providerId: 3159,
    providerName: 'SilverMob',
    policyUrl: 'https://silvermob.com/privacy'
  },
  {
    providerId: 3173,
    providerName: 'Kaden',
    policyUrl: 'https://kaden.ai/privacy-policy/'
  },
  {
    providerId: 3177,
    providerName: 'Kubient',
    policyUrl: 'https://kubient.com/privacy-policy/'
  }
]
